/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cli_OssInputs */

const en_mk_cli_oss = /** @type {(inputs: Mk_Cli_OssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI & MCP · command contracts available in the guides`)
};

const id_mk_cli_oss = /** @type {(inputs: Mk_Cli_OssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI & MCP · kontrak perintah tersedia di panduan`)
};

/**
* | output |
* | --- |
* | "CLI & MCP · command contracts available in the guides" |
*
* @param {Mk_Cli_OssInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cli_oss = /** @type {((inputs?: Mk_Cli_OssInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cli_OssInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cli_oss(inputs)
	return en_mk_cli_oss(inputs)
});